import { Box, Button, Card, Container, TextField, useMediaQuery } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ImageLinks } from "../../../../../../constants/image-link";

type Props = {};

interface IUserForm {
    username: string;
    password: string;
}

const userFormValidate = () => {
    return Yup.object({
        username: Yup.string()
            .min(3, "กรุณากรอกชื่อผู้ใช้งานอย่างน้อย 3 ตัวอักษร")
            .max(100, "กรุณากรอกชื่อผู้ใช้งานไม่เกิน 100 ตัวอักษร")
            .required("กรุณากรอกชื่อผู้ใช้งาน"),
        password: Yup.string()
            .min(6, "กรุณากรอกรหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร")
            .max(100, "กรุณากรอกรหัสผ่านไม่เกิน 100 ตัวอักษร")
            .required("กรุณากรอกรหัสผ่าน"),
    });
};

const ShopeeLogin = () => {
    const isMobile = useMediaQuery('(max-width:600px)')
    const userForm = useFormik<IUserForm>({
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: userFormValidate(),
        onSubmit: (values: IUserForm) => {
            window.location.href = "/marketplace/lazada/order";
        },
    });
    return (
        <Card
            elevation={3}
            sx={{
                padding: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: isMobile ? "auto" : "80vh",
            }}>
            <img
                style={{
                    width: isMobile ? "70%" : "30%",
                }}
                src={ImageLinks.LOGO_LAZADA_HORIZONTAL} alt="logo" />
            <Box
                sx={{
                    marginTop: 5
                }}
                component="form" mt={1} onSubmit={userForm.handleSubmit}>
                <TextField
                    id="username"
                    fullWidth
                    label="ชื่อผู้ใช้งาน"
                    name="username"
                    helperText={
                        userForm.touched.username && (userForm.errors.username as string)
                    }
                    error={!!(userForm.touched.username && userForm.errors.username)}
                    onBlur={userForm.handleBlur}
                    onChange={userForm.handleChange}
                    value={userForm.values.username}
                />
                <TextField
                    sx={{ marginTop: 2 }}
                    id="password"
                    fullWidth
                    label="รหัสผ่าน"
                    name="password"
                    type="password"
                    helperText={
                        userForm.touched.password && (userForm.errors.password as string)
                    }
                    error={!!(userForm.touched.password && userForm.errors.password)}
                    onBlur={userForm.handleBlur}
                    onChange={userForm.handleChange}
                    value={userForm.values.password}
                />
                <Button
                    size="large"
                    type="submit"
                    sx={{ marginTop: 2 }}
                    fullWidth
                    variant="contained">
                    เข้าสู่ระบบ
                </Button>
            </Box>
        </Card>
    );
}

export default ShopeeLogin;

//     import { Box, Button, Card, Container, TextField, useMediaQuery } from "@mui/material";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { ImageLinks } from "../../../../../../constants/image-link";

// type Props = {};

// interface IUserForm {
//     username: string;
//     password: string;
// }

// const userFormValidate = () => {
//     return Yup.object({
//         username: Yup.string()
//             .min(3, "กรุณากรอกชื่อผู้ใช้งานอย่างน้อย 3 ตัวอักษร")
//             .max(100, "กรุณากรอกชื่อผู้ใช้งานไม่เกิน 100 ตัวอักษร")
//             .required("กรุณากรอกชื่อผู้ใช้งาน"),
//         password: Yup.string()
//             .min(6, "กรุณากรอกรหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร")
//             .max(100, "กรุณากรอกรหัสผ่านไม่เกิน 100 ตัวอักษร")
//             .required("กรุณากรอกรหัสผ่าน"),
//     });
// };

// export default function Login({ }: Props) {
//     const isMobile = useMediaQuery('(max-width:600px)')
//     const userForm = useFormik<IUserForm>({
//         initialValues: {
//             username: "",
//             password: "",
//         },
//         validationSchema: userFormValidate(),
//         onSubmit: (values: IUserForm) => {
//             console.log(values);
//         },
//     });

//     return (
//         <div
//             style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 height: "100vh",
//                 backgroundColor: "#f5f5f5",
//             }}
//         >
//             <Container
//                 sx={{
//                     padding: 2,
//                 }}
//             >
//                 <Card
//                     elevation={3}
//                     sx={{
//                         padding: 2,
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         height: isMobile ? "auto" : "80vh",
//                     }}>
//                     <img
//                         style={{
//                             width: isMobile ? "70%" : "40%",
//                         }}
//                         src={ImageLinks.LOGO_SHOPEE} alt="logo" />
//                     <Box
//                         sx={{
//                             marginTop: 5
//                         }}
//                         component="form" mt={1} onSubmit={userForm.handleSubmit}>
//                         <TextField
//                             id="username"
//                             fullWidth
//                             label="ชื่อผู้ใช้งาน"
//                             name="username"
//                             helperText={
//                                 userForm.touched.username && (userForm.errors.username as string)
//                             }
//                             error={!!(userForm.touched.username && userForm.errors.username)}
//                             onBlur={userForm.handleBlur}
//                             onChange={userForm.handleChange}
//                             value={userForm.values.username}
//                         />
//                         <TextField
//                             sx={{ marginTop: 2 }}
//                             id="password"
//                             fullWidth
//                             label="รหัสผ่าน"
//                             name="password"
//                             type="password"
//                             helperText={
//                                 userForm.touched.password && (userForm.errors.password as string)
//                             }
//                             error={!!(userForm.touched.password && userForm.errors.password)}
//                             onBlur={userForm.handleBlur}
//                             onChange={userForm.handleChange}
//                             value={userForm.values.password}
//                         />
//                         <Button
//                             size="large"
//                             type="submit"
//                             sx={{ marginTop: 2 }}
//                             fullWidth
//                             variant="contained">
//                             เข้าสู่ระบบ
//                         </Button>
//                     </Box>
//                 </Card>
//             </Container>
//         </div>
//     );
// }
